import React, { forwardRef } from 'react'
import { Button, Modal } from '@ow/comps'
import Tree from '../../tree/tree'

const SelectOrg = function ({ closeModal, updateOrg, orgs }, ref) {
  const onSelectOrg = (keys, info) => {
    const { node } = info

    updateOrg(node)
    if (closeModal) {
      closeModal()
    }
  }

  return (
    <Modal
      ref={ref}
      title="选择组织"
      size="sm"
      showCloseButton
      // eslint-disable-next-line react/no-unstable-nested-components
      footer={() => (
        <Button stroke onClick={closeModal}>
          取消
        </Button>
      )}
      overlayStyle={{ zIndex: '1000' }}
    >
      <div className="w-full h-96 px-2 pb-2 flex justify-center">
        <div className="w-full">
          <Tree datas={orgs} onSelect={onSelectOrg} />
        </div>
      </div>
    </Modal>
  )
}

export default forwardRef(SelectOrg)
